import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useState } from "react";

export const CustomSearchBox = ({ searchString, setSearchString, apiCall, onClick, setCurrentPage }) => {
  const [timeoutId, setTimeoutId] = useState();

  const handleSearch = (e) => {
    setSearchString(e.target.value);
    let isSearch = true;
    clearTimeout(timeoutId);
    let _timeOutId = setTimeout(() => {
      apiCall(1, e.target.value);
    }, 2000);
    setTimeoutId(_timeOutId);
  };

  function handleClear(params) {
    setSearchString("");
    apiCall(1, "");
    setCurrentPage(1);
  }

  return (
    <div className="custom_search_wrapper">
      {searchString && (
        <div className="clear_search_value_wrapper" onClick={() => handleClear()}>
          <FontAwesomeIcon icon={faXmark} className="icon" />
        </div>
      )}
      <input
        type="text"
        placeholder="Search..."
        value={searchString}
        onChange={(e) => handleSearch(e)}
        className="form-control search_input"
      />

      <div
        className="search_button"
        onClick={onClick}
      // style={{ backgroundColor: "transparent" }}
      >
        <FontAwesomeIcon
          icon={faMagnifyingGlass}
          className="icon"
          style={{ color: "#DE4B6E" }}
        />
      </div>
    </div>
  );
};
